import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OpdchartService } from 'src/app/private/services/opdchart.service';
import { TemplateService } from 'src/app/private/services/template.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Subject, Subscription, debounceTime } from 'rxjs';
import Prescription from 'src/app/utils/printLayout/GeneratePrescription';
import { ActivatedRoute } from '@angular/router';
import { PrescriptionService } from 'src/app/utils/printService/prescription.service';
import { OpdRefreshService } from 'src/app/private/services/opd-refresh.service';

@Component({
  selector: 'app-prescriptions',
  templateUrl: './prescriptions.component.html',
  styleUrls: ['./prescriptions.component.scss']
})
export class PrescriptionsComponent implements OnDestroy {
  @Input() app_data:any
  id:any;
  @Input() titleOfHead: any = {
    title: 'OPD',
    root: 'Prescriptions'
  };
  @Input() patient:any
  medicineDb:any = [];
  btnSaveLoading:boolean = false;
  btnShareLoading:boolean = false;
  medicationListData:any = []
  count:any = 0;
  drugList:any = [];
  tempDrugList:any = []
  templateDugList:any = [];
  templateName:any = ""
  templateSaveButton:boolean =false
  filteredMedicines:any = []
  tempMedicine:any = [];
  searchLoading = false;
  printButtonLoading:boolean = false;
  printPrescriptionObject:any;
  drugSearch = new Subject<string>();
  print_option:any = ['primary_checkups','medications'];

  currentTab:any;
  medicineObject = {
    drug_type:"",
    drug_name:"",
    dosage: {}
  }
  current_app_id:any;
  current_patient_id:any;
  private _refreshSub?: Subscription;

  constructor(public printPrescriptionService:PrescriptionService, public route:ActivatedRoute,private opdChartAPI:OpdchartService, private toast:ToastrService, public dialog: MatDialog,private modalService: NgbModal,private api:TemplateService,private localStorage:LocalStorageService, private opdRefreshService: OpdRefreshService)
  {
    this.route.params.subscribe(params =>
      {
        this.current_patient_id = params['id']
        this.current_app_id = params['app_id']
      })
  }

 
  ngAfterViewInit()
{
  this.getPatientMedicationData();
  // Auto-reload whenever Medications tab saves — no tab switch needed
  this._refreshSub = this.opdRefreshService.prescriptionSaved$.subscribe(() => {
    this.getPatientMedicationData();
  });
}

ngOnDestroy() {
  this._refreshSub?.unsubscribe();
}

getPatientMedicationData()
{
// console.log(this.app_data)
 let param = {
   where:{
  hospital_id:this.localStorage.getHospitalId(),
   center_id:this.localStorage.getCenterId(),
   patient_id:this.current_patient_id,
   },
   // Fetch all columns so print/preview has primary_checkups, investigations,
   // ophthalmic_examinations, advices and medications all in one record
 }
 this.opdChartAPI.getAllOpdChartData(param).subscribe({
   next:(res)=>{
    if(res)
    {
      const processedRes = res.map((item: any) => {
        if (item.medications) {
          const metaItem = item.medications.find((m: any) => m.drug_type === 'HANDWRITTEN_METADATA');
          return {
            ...item,
            handwritten_prescription: metaItem ? metaItem.handwritten_prescription : (item.handwritten_prescription || ''),
            medications: item.medications.filter((m: any) => m.drug_type !== 'HANDWRITTEN_METADATA')
          };
        }
        return item;
      });

      this.count = processedRes.filter((item:any)=>{return item.medications && item.medications.length > 0}).length;
      this.medicationListData = processedRes.filter((item:any)=>{return item.app_id != this.app_data.appointment.app_id && item.medications && item.medications.length > 0 });
      let existingObject  = processedRes.filter((item:any)=>{return item.app_id == this.app_data.appointment.app_id })[0]
      if(existingObject!=undefined)
      {
        this.id =  existingObject.id || undefined;
        // Store the full record so all sections are available for print/preview
        this.currentTab = existingObject;
      }
   
    
    }

   },
   error:(e)=>{

   }
 })
}
  
  hasData(key: string): boolean {
    if (!this.printPrescriptionObject) return false;
    const obj = this.printPrescriptionObject;
    
    if (key === 'primary_checkups') {
      return obj.primary_checkups && Object.values(obj.primary_checkups).some(val => val !== null && val !== '');
    }
    
    if (key === 'investigations') {
      return obj.investigations && obj.investigations.length > 0;
    }
    
    if (key === 'medications') {
      return obj.medications && obj.medications.filter((m: any) => m.drug_type !== 'HANDWRITTEN_METADATA').length > 0;
    }
    
    if (key === 'advices') {
      return obj.advices && ((obj.advices.advices && obj.advices.advices.length > 0) || obj.advices.nextVisit);
    }
    
    const eyeExam = obj.ophthalmic_examinations;
    if (!eyeExam) return false;

    if (key === 'auto_refraction') {
      return this.hasObjectData(eyeExam.auto_refraction);
    }
    if (key === 'vision_acuity') {
      return this.hasObjectData(eyeExam.vision_acuity);
    }
    if (key === 'refraction') {
      return this.hasObjectData(eyeExam.refraction);
    }
    if (key === 'anterior_segment') {
      return this.hasObjectData(eyeExam.anterior_segment);
    }
    if (key === 'fundus_examination') {
      return this.hasObjectData(eyeExam.fundus_examination);
    }
    if (key === 'iop') {
      return this.hasObjectData(eyeExam.iop);
    }

    return false;
  }

  hasObjectData(subObj: any): boolean {
    if (!subObj) return false;
    if (typeof subObj !== 'object') {
      return subObj !== null && subObj !== '';
    }
    return Object.values(subObj).some(val => this.hasObjectData(val));
  }

  createPrescription(prescription:any,item:any)
  {
    // Merge currentTab (full record with all sections) with the selected item
    // so the PDF always has primary_checkups, investigations, ophthalmic_examinations, advices
    const fullRecord = { ...(this.currentTab || {}), ...item };
    this.printPrescriptionObject = fullRecord;
    // Filter default print options to only include sections with actual data
    this.print_option = [];
    const keysToCheck = [
      { key: 'primary_checkups', val: 'primary_checkups' },
      { key: 'investigations', val: 'investigations' },
      { key: 'auto_refraction', val: 'auto_refraction' },
      { key: 'vision_acuity', val: 'vision_acuity' },
      { key: 'refraction', val: 'refraction' },
      { key: 'anterior_segment', val: 'anterior_segment' },
      { key: 'fundus_examination', val: 'fundus_examination' },
      { key: 'iop', val: 'iop' },
      { key: 'advices', val: 'advices' },
      { key: 'medications', val: 'medications' }
    ];
    keysToCheck.forEach(opt => {
      if (this.hasData(opt.key)) {
        this.print_option.push(opt.val);
      }
    });

    this.modalService.open(prescription,  {  fullscreen: true, scrollable: false,ariaLabelledBy: 'modal-basic-title' });
    console.log("Print object (merged): ", this.printPrescriptionObject);
    setTimeout(() => {
      this.viewPrescription();
    }, 1000);
   
  }

   async addPrintOption(event:any){

    if(event.target.checked){
      this.print_option.push(event.target.value)
    
    }
     
    else{
      this.print_option = this.print_option.filter((item:any)=> item != event.target.value)
      //this.print_option.pop(event.target.value)
    }
    this.viewPrescription();
  }
  async viewPrescription(){
    // console.log(this.print_option)
     let param = {
       print_option:this.print_option,
       patientInfo:this.app_data,
       patient_id:this.current_patient_id,
       pId:this.app_data.pId,
       app_id:this.current_app_id,
       prescription:this.printPrescriptionObject,
     }
     console.log("prisss : ",param);
     const pdfData = await this.printPrescriptionService.generatePdf(param,"view");
     const targetElement:any = document.querySelector('#viewPdf');
     const iframe:any = document.createElement('iframe');
     iframe.src = pdfData;
     iframe.width = "100%";
     iframe.height = "100%";
     iframe.style.border = "none";
     iframe.style.borderRadius = "8px";
     iframe.style.boxShadow = "0 4px 12px rgba(0,0,0,0.05)";
     while (targetElement.firstChild) {
      targetElement.removeChild(targetElement.firstChild);
  }
     targetElement.appendChild(iframe);
   
     console.log(pdfData)
   }
  printPrescription(){
   // console.log(this.print_option)
    let param = {
      print_option:this.print_option,
      patientInfo:this.app_data,
      patient_id:this.current_patient_id,
      pId:this.app_data.pId,
      app_id:this.current_app_id,
      prescription:this.printPrescriptionObject,
    }
    console.log("printn3 33 : ",param)
    this.printPrescriptionService.generatePdf(param,"print");
  }
 async sharePrescription(){
    // console.log(this.print_option)
    this.btnShareLoading = true;
     let param = {
       print_option:this.print_option,
       patientInfo:this.app_data,
       patient_id:this.current_patient_id,
       pId:this.app_data.pId,
       app_id:this.current_app_id,
       prescription:this.printPrescriptionObject,
     }
   //  console.log(param)
     const ddd =  await this.printPrescriptionService.generatePdf(param,"email")
     this.btnShareLoading = false;
     console.log(ddd)
   }
  
}
